import React, { useState, useEffect } from 'react';
import axios from 'axios';
import util from 'util';
import constClass from '../../Constants/Constants';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { useToasts } from 'react-toast-notifications';

const BackyardCheckInPanel = (props) => {
  const { user, userActions } = props;
  const [orderData, setOrderData] = useState(null);
  const [number, setNumber] = useState(null);
  const [lockData, setLockData] = useState(false);
  const { addToast, removeAllToasts } = useToasts();

  const refreshOrder = async () => {
    const reg_params = {
      "operator": "or",
      "where": [
        {
          "status": constClass.STATUS.REG
        },
        {
          "status": constClass.STATUS.PRE
        },
        {
          "status": constClass.STATUS.CHK
        },
        {
          "status": constClass.STATUS.CHLD
        },
        {
          "status": constClass.STATUS.CABS
        },
        {
          "status": constClass.STATUS.AABS
        }
      ]
    }
    const data = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/order/search/`, reg_params)).data;
    data.sort((a, b) => a.order_id - b.order_id);
    setOrderData(data);
    const num = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/saiban/`)).data;
    setNumber(num.find(n => n.shop_id === user.shopId) ? num.find(n => n.shop_id === user.shopId).number + 1 : 1);
  }

  const handleStatusButtonClick = async (order_id, status) => {
    if (orderData.find(o => o.order_id === order_id).status === status) {
      return;
    }
    const params = {
      status,
      user_id: [constClass.STATUS.CALL, constClass.STATUS.FIN, constClass.STATUS.CCL].includes(status) ? user.userId : null,
    };
    try {
      setLockData(true);
      await axios.put(`${process.env.REACT_APP_BACKEND_URL}/order/status/${order_id}`, params);
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });  
      }
    } finally {
      await refreshOrder();
      setLockData(false);
    }
  }

  const renderButton = (data, status, statusName, additionalStatus = []) => {
    additionalStatus.push(status);
    statusName = [constClass.STATUS_NAME.CALL, constClass.STATUS_NAME.PRE].includes(statusName) && additionalStatus.includes(data.status) ? statusName + '中' : statusName;
    return (
      <button type="button"
        disabled={lockData}
        className={`btn ${additionalStatus.includes(data.status) ? 'btn-danger' : (constClass.ACTIVE_BUTTONS[data.status].includes(status) ? 'btn-primary' : 'btn-secondary')} mx-1`}
        onClick={() => handleStatusButtonClick(data.order_id, status)}>
        {statusName}
      </button>
    )
  }

  const countOrder = (status) => {
    return orderData.reduce((prev, item) => { return prev + (item[constClass.COLUMN.CLASS] === props.user_class && status.includes(item.status) ? 1 : 0) }, 0);
  }

  useEffect(() => {
    var intervalId;
    async function fetchData() {
      await refreshOrder();
      intervalId = setInterval(() => {
        refreshOrder();
      }, 5000);
      return () => {
        clearInterval(intervalId);
      };
    }
    return fetchData();
  }, []);

  return (
    <div className="container">
      <div className="row d-none"><div className="col-12">{util.inspect(orderData)}</div></div>
      <div className="row d-none"><div className="col-12">{util.inspect(user)}</div></div>
      {orderData === null && <div className="row"><div className="col-12">読み込み中・・・</div></div>}
      {orderData !== null && (
        <div className="row border mb-3 p-2">
          <div className="col-4 text-center">
            <span>待ち人数：{countOrder([constClass.STATUS.REG])} 名</span>
          </div>
          <div className="col-4 text-center">
            <span>保留人数：{countOrder([constClass.STATUS.CHLD])} 名</span>
          </div>
          <div className="col-4 text-center">
            <span>不在人数：{countOrder([constClass.STATUS.CABS, constClass.STATUS.AABS])} 名</span>
          </div>
          <div className="col-4 text-center">
            <span>事前呼出中人数：{countOrder([constClass.STATUS.PRE])} 名</span>
          </div>
          <div className="col-4 text-center">
            <span>チェックイン済み人数：{countOrder([constClass.STATUS.CHK])} 名</span>
          </div>
          <div className="col-4 text-center">
          </div>
          <div className="col-12 text-right">
            <span>次の発券番号：{constClass.RECEIPT_NUM[props.user_class]}{number} 番</span>
          </div>
        </div>
      )}
      {orderData !== null && (
        <div className="row mb-3 p-0">
          <div className="col-12 p-0">
            <table className="table table-bordered table-striped">
              <thead className={`table-${constClass.COLOR[props.user_class]}`}>
                <tr>
                  <td className="text-center">
                    順番
                  </td>
                  <td className="text-center">
                    受付番号
                  </td>
                  <td className="text-center">
                    発券時刻
                  </td>
                  <td className="text-center">
                    発売/払戻
                  </td>
                  <td className="text-center">
                    支払方法
                  </td>
                  <td className="text-center">
                    種別
                  </td>
                  <td className="text-center">
                    ステータス
                  </td>
                  <td className="text-center">
                    チェックイン/取消
                  </td>
                </tr>
              </thead>
              <tbody>
                {orderData.filter(o => o[constClass.COLUMN.CLASS] === props.user_class && o.status !== constClass.STATUS.CHK).map((data, idx) => (
                  <tr key={data.order_id}>
                    <td className="text-center align-middle">
                      {idx + 1}
                    </td>
                    <td className="text-center align-middle">
                      {data.receipt_num ? data.receipt_num : '-'}
                    </td>
                    <td className="text-center align-middle">
                      {data.ins_date ? moment(data.ins_date).format('HH:mm') : '-'}
                    </td>
                    <td className="text-center align-middle">
                      {constClass.PAYMENT_NAME[data[constClass.COLUMN.PAYMENT]]}
                    </td>
                    <td className="text-center align-middle">
                      {constClass.METHOD_NAME[data[constClass.COLUMN.METHOD]]}
                    </td>
                    <td className="text-center align-middle">
                      {data.line_id === constClass.PAPER_ORDER ? '紙' : 'LINE'}
                    </td>
                    <td className="text-center align-middle">
                      {renderButton(data, constClass.STATUS.PRE, constClass.STATUS_NAME.PRE)}
                      {renderButton(data, constClass.STATUS.CHLD, constClass.STATUS_NAME.CHLD)}
                      {renderButton(data, constClass.STATUS.CABS, constClass.STATUS_NAME.CABS, [constClass.STATUS.AABS])}
                    </td>
                    <td className="text-center align-middle">
                      {renderButton(data, constClass.STATUS.CHK, constClass.STATUS_NAME.CHK)}
                      {renderButton(data, constClass.STATUS.CCCL, constClass.STATUS_NAME.CCCL)}
                    </td>
                  </tr>
                ))
                }
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  )
}

export default BackyardCheckInPanel;